module.exports = __webpack_public_path__ + "img/SketchPng0b2979a72f34bfa5b0e25f47fb3032198c560aba5ed31a5847e8b6beb88b7d22.85c41fba.png";